import PropTypes from 'prop-types';
import React from 'react';

import './FeatureIcon.scss';

const defaultCode = 'E917';

const FeatureIcon = ({ code, description }) => {
    const hasDefaultIconCode = !code || code === defaultCode;
    const iconClassName = hasDefaultIconCode ? 'default-feature-icon icon-plus' : `icon-${code}`;

    return (
        <li className="features-bloc">
            <div className="features-bloc--icon">
                <icon className={iconClassName} />
            </div>
            <div className="features-bloc--content">{description}</div>
        </li>
    );
};

FeatureIcon.propTypes = {
    code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    description: PropTypes.string.isRequired,
};

FeatureIcon.displayName = 'FeatureIcon';

export default FeatureIcon;
